import React from "react";
import { Product } from "../models/ticket";
import { calculateTotalValue } from "../utils/calculateTotalValue";
import { formatCurrency } from "../utils/formatCurrency";

interface TotalValueProductsProps {
  listProducts: Product[];
}

function TotalValueProducts({ listProducts }: TotalValueProductsProps) {
  const totalValue = formatCurrency(calculateTotalValue(listProducts));

  return (
    <div className="containerTotalProducts">
      <span>Valor total</span>
      <span className="price">{totalValue}</span>
    </div>
  );
}

export { TotalValueProducts };
